import React from 'react';
import { Button, ButtonVariant } from '@amzn/atoz-web/Button';
import { Row } from '@amzn/atoz-web/Row';
import { Text } from '@amzn/atoz-web/Text';
import { Card } from '@amzn/atoz-web/Card';
import { Duration as LuxonDuration } from 'luxon';
import { useTranslation } from 'react-i18next';
import { useNavigate } from '../../../../hooks';
import { Routes } from '@amzn/atoz-shiftapp-initializer';
import { styledWithTheme } from '@amzn/atoz-web/Theme';
import { siteIdParam } from '../../../../config/queryParams';
export function roundDecimals(value, decimals) {
    if (decimals < 0) {
        decimals = 0;
    }
    var multiplier = Math.pow(10, decimals);
    return Math.round(value * multiplier) / multiplier;
}
export var LocationCard = function (_a) {
    var site = _a.site, eligibleDuration = _a.eligibleDuration, isAvailable = _a.isAvailable, fromHome = _a.fromHome;
    var t = useTranslation().t;
    var navigate = useNavigate();
    var locationName = "".concat(site.lineOfBusiness, " - ").concat(site.name);
    var eligibileHours = LuxonDuration.fromISO(eligibleDuration.value).as('hours');
    return (React.createElement(LocationCardContainer, { "data-testid": "LocationCard-".concat(site.id), margin: { top: 'S200', bottom: 'S200' } },
        React.createElement(Row, null,
            React.createElement(Text, { fontSize: "T300", fontWeight: "bold" }, locationName)),
        React.createElement(Row, null,
            React.createElement(Text, { fontSize: "T200" }, "".concat(roundDecimals(eligibileHours, 1), " ").concat(t('shift_management_locationEligibility_hoursLeft')))),
        React.createElement(Row, { justifyContent: "flex-end" }, isAvailable && (React.createElement(Button, { key: "find-shifts-".concat(site.id), dataTestId: "find-shifts-".concat(site.id), variant: ButtonVariant.Secondary, onClick: function () {
                return navigate("".concat(fromHome
                    ? Routes.FindShiftsDashboardBase
                    : Routes.FindShifts, "?ref=loc_elg&").concat(siteIdParam, "=").concat(encodeURIComponent(site.id)));
            } }, t('shift_management_locationEligibility_findShifts'))))));
};
var LocationCardContainer = styledWithTheme(Card)(function (_a) {
    var theme = _a.theme;
    return "\n        border: none;\n        display: flex;\n        background-color: white;\n        flex-direction: column;\n        padding: ".concat(theme.selectors.space('S300'), "px\n    ");
});
